import styled from "styled-components";
import { Outlet } from "react-router-dom";
import { useState } from "react";
import LessonInfo from "./LessonInfo";
import LessonListView from "./LessonListView";
import { scrollbar } from "features/homework/homeworkUi";

const LessonManage = () => {
    const [clickedLesson, setClickedLesson] = useState("");
    return (
        <Body>
            <Outlet />
            <LessonInfo clickedLesson={clickedLesson} />
            <LessonListView clickedItem={clickedLesson} setClickedItem={setClickedLesson} />
        </Body>
    );
};

const Body = styled.div`
    position: relative;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(300px, 360px);
    gap: 16px;
    flex: 1;
    min-height: 0;
    width: 100%;

    @media (max-width: 960px) {
        grid-template-columns: minmax(0, 1fr);
        overflow: auto;
        ${scrollbar}
    }
`;

export default LessonManage;
